import { Action } from 'redux';

import { RouterErrorHide, RouterErrorShow } from '../../app/actions/AppActionTypes';
import { isActionFactory } from '../../app/actions/isActionFactory';
import { RouterErrorType } from '../../app/state/RouterErrorType';

export interface ShowRouterErrorAction extends Action {
  errorType: RouterErrorType;
  redirectSiteUrlName: string;
}

export function showRouterError(errorType: RouterErrorType, redirectSiteUrlName?: string): ShowRouterErrorAction {
  return {
    type: RouterErrorShow,
    errorType,
    redirectSiteUrlName: redirectSiteUrlName || ''
  };
}

export const isShowRouterErrorAction = isActionFactory<ShowRouterErrorAction>(RouterErrorShow);

export interface HideRouterErrorAction extends Action {}

export function hideRouterError(): HideRouterErrorAction {
  return {
    type: RouterErrorHide
  };
}

export const isHideRouterErrorAction = isActionFactory<HideRouterErrorAction>(RouterErrorHide);
